<!-- <div class="container text-center my-3">
  <div class="row mx-auto my-auto">
    <div id="myCarousel" class="carousel slide w-100" data-ride="carousel">
      <div class="carousel-inner" role="listbox">
        <div class="carousel-item py-5 active">
          <div class="row">
            <div class="col-sm-3" *ngFor="let additionalSectionCard of additionalSectionCards">
              <div class="card">
                <div class="card-body">
                  <div class="outer-tile">
                    <div class="image-tile show-image" style="background-image: url('{{ additionalSectionCard.headImage }}');"></div>
                  </div>
                  <h5>{{ additionalSectionCard.title }}</h5>
                  <p>{{ additionalSectionCard.body }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
         <div class="carousel-item py-5">
          <div class="row">
            <div class="col-sm-3" *ngFor="let additionalSectionCard of additionalSectionCards">
              <div class="card">
                <div class="card-body">
                  <div class="outer-tile">
                    <div class="image-tile show-image" style="background-image: url('{{ additionalSectionCard.headImage }}');"></div>
                  </div>
                  <h5>{{ additionalSectionCard.title }}</h5>
                  <p>{{ additionalSectionCard.body }}</p>
                  <div class="button-center">
                    <a class="btn btn-primary" *ngIf="additionalSectionCard.buttonUrl || additionalSectionCard.buttonText" [href]="additionalSectionCard.buttonUrl" role="button" target="_blank">
                      {{ additionalSectionCard.buttonText }}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
        </div> 
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <a class="carousel-control-prev text-dark" href="#myCarousel" role="button" data-slide="prev">
        <span class="fa fa-chevron-left" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next text-dark" href="#myCarousel" role="button" data-slide="next">
        <span class="fa fa-chevron-right" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
  </div>
</div> -->

<!-- <script>
  $('#myCarousel').carousel({
  interval: 5000
})

</script> -->

<div class="additional-carousel">
  <div class="card" *ngFor="let additionalCarousalSectionCard of additionalCarousalSectionCards">
    <div class="card-body">
      <div class="outer-tile">
        <div class="image-tile show-image" style="background-image: url('{{ additionalCarousalSectionCard.headImage }}');"></div>
      </div>
      <h5>{{ additionalCarousalSectionCard.title }}</h5>
      <p>{{ additionalCarousalSectionCard.body }}</p>
      <div class="button-center">
        <a
          class="btn btn-primary"
          *ngIf="additionalCarousalSectionCard.buttonUrl || additionalCarousalSectionCard.buttonText"
          [href]="additionalCarousalSectionCard.buttonUrl"
          role="button"
          target="_blank"
        >
          {{ additionalCarousalSectionCard.buttonText }}</a
        >
      </div>
    </div>
  </div>
</div>
